export class SachetStock {

    code: string;
    redCount: number = 0;
    yellowCount: number = 0;
    counter: number = 0;
    organization: string;
    organizationId: number;
    sachetType: string;
    lastUpdate: Date;
    token: string;
    active: boolean = true;
    date: Date;
    dateTimestamp: number;
    color: string;
}
